/// <reference path="./backend_api.js" />

console.log("register.js loaded");

const  handleRegister = async(data) => {
  const url = `${BASE_URL}/auth/signup`;

  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
       headers: {
        "Content-Type": "application/json", // Set the content type to JSON
        [SK_AUTH_MODE_HEADER]: "cookie",
      },
      body : JSON.stringify(data)
    });
    const response1 = await response.json();
    if (checkHttpStatus(response.status) === HttpStatus.OK) {
    // OLD: if (response1?.status === 200) {

      if(!SK.USER_VERIFICATION_REQUIRED) {
        clearLegacyAuthTokens();
        setUser(response1?.data?.user);
      }
      showSuccessPopup(SK.tMsg(response1?.message));
      // Redirect to the specified URL
       setTimeout(() => {
          window.location.href = "https://skilltrack.fun/en?_ab=0&_fd=0&_sc=1";
          }, 3000);
    } else {
      // Handle other statuses or show an error message
      //OLD: showErrorPopup(response1?.message); 
      showErrorPopup(SK.tMsg(response1?.message || "errors.quizCreation", "Error"));
      console.error("Unexpected status:", response1?.status);
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
  
}

function handleSignup() {
  const firstName = document.getElementById('RegisterForm-FirstName')?.value.trim();
  const surname = document.getElementById('RegisterForm-LastName')?.value.trim();
  const email = document.getElementById('RegisterForm-email')?.value.trim();
  const password = document.getElementById('RegisterForm-password')?.value.trim();
  handleRegister({ firstName, surname, email, password });
}
